var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button-row',{attrs:{"items":!_vm.words||_vm.words.length===0?'Здесь будут подсказки при вводе'.split(' '):_vm.words,"color":_vm.register===null?'secondary':_vm.register?'accent':'primary'},on:{"buttonclick":(n,i)=>{_vm.shortcut(i)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }